import { PlanGrid } from "../BusinessPlanTile/BusinessPlans";
import BusinessPlanCard from "../BusinessPlanTile/BusinessPlanCard";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Title, Body } from "@vds3/typography";
import { color } from "@vds-tokens/core";
import { Text } from "@vds/core";
import { PlanTile } from "@vbg-ds/core";
import { useSelector } from "react-redux";
import { MarginSpacerM } from "common/components/styleTag";
import { htmlDecode, formatPriceString } from "utils/commonUtils";
import { Button } from "@vds3/buttons";
import { ModalTitle, ModalFooter } from "@vds3/modals";
import { convertStringToElements } from "@vds/html-parsers";
import { DivWrapper, MobileCarousel, ModalWrapper } from "./Common";
import {
	ByodContainer,
	ByodImg,
} from "pages/ShoppingCart/components/CartPackage/styles";

export const Header = ({
	image,
	packageDesc,
	capacity,
	color,
	selectedPlan,
	id,
	byod,
	eyebrow,
	isStickyHeader = false,
}) => {
	return (
		<div style={{ display: "flex", alignItems: "center" }} id={id}>
			{image !== null && image ? (
				<div>
					<img
						src={image}
						alt="image"
						width={isStickyHeader ? "40px" : "72px"}
						height={isStickyHeader ? "40px" : "72px"}
					/>
				</div>
			) : (
				<ByodContainer width={"auto"} height={"auto"}>
					<ByodImg />
				</ByodContainer>
			)}
			<div style={{ marginLeft: "10px" }}>
				<Body size="large" bold={false}>
					{eyebrow}
				</Body>
				<Body size="large" bold={true}>
					{packageDesc}
				</Body>
				<Body size="large">
					{byod ? "Your own device" : <></>}
					{capacity && capacity}
					{capacity && color && ", "}
					{color && color}
				</Body>
				<Body size="large">{selectedPlan && selectedPlan}</Body>
			</div>
		</div>
	);
};

export const PlansCards = ({
	plans,
	displayName,
	onSelectPlan = () => {},
	selectedPlans,
	packageId,
	elegibleBillingCode,
	fromPlansNew
}) => {
	const deviceCompatiblePlansInfo = useSelector(
		(state) => state.ProspectWidgets_WirelessPlansData.deviceCompatiblePlansInfo
	);
	const arePromosPresent = plans.some((i) => i?.promoEligible);
	const { t } = useTranslation(["plans"]);
	const plansAEM = t("plans", { ns: "plans", returnObjects: true });
	const isAutopayDiscount = displayName === "Smartphones";
	const isRecommended = (planCode) =>
		plansAEM?.aggregate_plans?.plansRecommended?.length &&
		plansAEM.aggregate_plans.plansRecommended.includes(planCode);
	const discountedPrice =
		deviceCompatiblePlansInfo?.configuration?.discount?.autoPayDiscount;
	let plansToRender = plans.map((plan) => {
		const {
			displayName,
			monthlyFee,
			planDiscountMonthlyFee,
			promoEligible,
			name,
			retailPrice,
		} = plan || {};
		const recommended = isRecommended(plan.billingCode);
		return {
			title: {
				size: "titleSmall",
				primitive: "h1",
				children: (
					<BusinessPlanCard
						height={"auto"}
						minHeight={690}
						key={plan.billingCode}
						planDetail={plan}
						autoPayDiscount={isAutopayDiscount && discountedPrice}
						isEnabled={true}
						onSelect={() =>
							onSelectPlan(plan.billingCode, plan.displayName, plan.promoEligible)
						}
						tierPrices={
							deviceCompatiblePlansInfo?.staticContent &&
							deviceCompatiblePlansInfo?.staticContent[plan.billingCode]
						}
						aemFeatures={
							plansAEM?.planFeatures && plansAEM.planFeatures[plan.billingCode]
						}
						isRecommended={isRecommended(plan.billingCode)}
						promoSpacing={arePromosPresent}
						fromPlansNew={true}
						fromPlansNewCt={fromPlansNew}
						elegibleBillingCode={elegibleBillingCode}
						selected={
							selectedPlans !== null &&
							selectedPlans &&
							selectedPlans[packageId] !== null &&
							selectedPlans[packageId] &&
							selectedPlans[packageId]["billingCode"] === plan.billingCode
								? true
								: false
						}
					/>
					// <PlanTile
					// 	height={"auto"}
					// 	paddingTop={"1.5rem"}
					// 	paddingBottom={"1.5rem"}
					// 	blocks={[
					// 		{
					// 			height: "auto",
					// 			kind: "header",
					// 			paddingTop: "1.5rem",
					// 			paddingBottom: "1.5rem",
					// 			badge: recommended
					// 				? {
					// 						backgroundColor: "black",
					// 						children: "Recommended",
					// 				  }
					// 				: null,
					// 			title: {
					// 				children: htmlDecode(displayName ?? name),
					// 				size: "large",
					// 				color: "var(--vds-color-element-brandhighlight-onlightprimary)",
					// 			},
					// 		},
					// 		{
					// 			height: "auto",
					// 			kind: "price",
					// 			prices: [
					// 				{
					// 					price: {
					// 						children: formatPriceString(monthlyFee),
					// 					},
					// 					helperText: {
					// 						alignment: "middle",
					// 						leadingText:
					// 							"/ line per month Plus taxes, fees apply. Economic Adjustment Charge may apply.",
					// 					},
					// 				},
					// 			],
					// 		},
					// 	]}
					// />
				),
			},
		};
	});
	return (
		<>
			<DivWrapper>
				<PlanGrid>
					{plansToRender.map((plan) => plan["title"]["children"])}
				</PlanGrid>
			</DivWrapper>
			{!!plansToRender?.length && <MobileCarousel data={plansToRender} />}
		</>
	);
};

const PlansAddMoreContainer = styled.div`
	display: flex;
	justify-content: space-between;
	@media only screen and (min-width: 545px) {
		padding-top: 1rem;
	}

	@media only screen and (max-width: 545px) {
		display: block;
		flex-direction: row;
		> h2 {
			padding-top: 1rem;
			padding-bottom: 1rem;
		}
	}
`;

export const SelectDevices = ({
	addMoreDevice = () => {},
	updateAddMoreDevicePopup,
	pageHeaderSticky,
}) => {
	const { t } = useTranslation(["plans"]);
	return (
		<>
			{pageHeaderSticky ? (
				<PlansAddMoreContainer>
					<Text
						kind="title"
						size="xlarge"
						primitive="h2"
						color={color.element.brandhighlight.onlightprimary}
					>
						Select plan
						{/* {t("plans.aggregate_plans.heading", { ns: "plans" })} */}
					</Text>
					<Button
						use="secondary"
						size="small"
						className="add-devices"
						data-track="Add More Device"
						onClick={updateAddMoreDevicePopup}
					>
						Add more devices
					</Button>
				</PlansAddMoreContainer>
			) : (
				<>
					<MarginSpacerM />
					<Text
						kind="title"
						size="xlarge"
						primitive="h2"
						color={color.element.brandhighlight.onlightprimary}
					>
						Select plan
						{/* {t("plans.aggregate_plans.heading", { ns: "plans" })} */}
					</Text>
					<MarginSpacerM />
					<Button
						use="secondary"
						size="small"
						className="add-devices"
						data-track="Add More Device"
						onClick={updateAddMoreDevicePopup}
					>
						Add more devices
					</Button>
					<MarginSpacerM />
				</>
			)}
		</>
	);
};

export const ApplyToAllModal = ({
	category = "",
	showModal = false,
	handleModal = () => {},
	applyPlansToDevices = () => {},
}) => {
	const { t } = useTranslation(["plans"]);
	return (
		<ModalWrapper
			opened={showModal}
			fullScreenDialog={false}
			disableAnimation={false}
			disableOutsideClick={true}
			onOpenedChange={(val) => {
				if (!val) handleModal(val);
			}}
			data-track="close"
			disableFocusLock={true}
		>
			<ModalTitle>
				{t("plans.aggregate_plans.modalTitle", {
					ns: "plans",
					category: String(category).toLowerCase(),
				})}{" "}
			</ModalTitle>
			<ModalFooter
				buttonData={{
					primary: {
						width: "100%",
						children: t("plans.aggregate_plans.applyToAll", { ns: "plans" }),
						onClick: () => applyPlansToDevices("all"),
						"data-track": t("plans.aggregate_plans.applyToAll", { ns: "plans" }),
					},
					close: {
						width: "100%",
						children: t("plans.aggregate_plans.OnlyThisDevice", { ns: "plans" }),
						onClick: () => applyPlansToDevices("current"),
						"data-track": t("plans.aggregate_plans.OnlyThisDevice", { ns: "plans" }),
					},
				}}
			/>
		</ModalWrapper>
	);
};
